<template>
  <!-- 发帖，普通帖子 -->
  <div class="add-post">
    <uploaderVideo ref="uploadDiv" :uploadType="1" @uploadSucc="handleUploadSucc"></uploaderVideo>
    <div class="upload-title">
      <input type="text" maxlength="50" v-model="subjectName" placeholder="填写标题,会有更多点赞哦~" class="input-title" />
    </div>
    <!-- maxlength="50" -->
    <quill-editor v-model="content" :options="editorOption"></quill-editor>
    <!-- <van-field v-model="content" rows="6" autosize type="textarea" placeholder="请输入内容" show-word-limit /> -->
    <div class="radio1" v-if="this.fromType === 'case'">
      <div class="div-flex">
        <div class="flex-label">是否匿名</div>
        <van-radio-group v-model="changeRadio" direction="horizontal">
          <van-radio icon-size="14px" checked-color="#EB1700" name="1">是</van-radio>
          <van-radio icon-size="14px" checked-color="#EB1700" name="0">否</van-radio>
        </van-radio-group>
      </div>
      <van-field readonly clickable name="picker" class="field-color about-teacher" :value="caseValue" label="疾病分类"
        placeholder="点击选择疾病分类" @click="showPicker = true" />
      <van-popup v-model="showPicker" position="bottom">
        <van-picker show-toolbar title="选择疾病分类" :columns="columnsCase" @confirm="onConfirm"
          @cancel="showPicker = false" />
      </van-popup>
    </div>
    <div class="fixed-btn" :class="{ cur: allInput, upload: uploadPost }" @click="handleAddPost">发布帖子</div>
    <div class="dialog-fixed" v-if="visiableAdd">
      <div class="dialog-bg"></div>
      <div class="dialog-cons">
        <div class="cons-title">温馨提示</div>
        <div class="cons-txt">
          因个人信息保护、广告法等相关法律法规要求，您所发布的帖子可能需要后台人员审核后方可展示。
          <div class="txt2">
            参考：<span class="col">文字帖</span>审核<span class="col">周期2小时</span>;<br>
            含<span class="col">图片/视频帖</span>审核<span class="col">周期1-3天</span>。
          </div>
        </div>
        <div class="cons-btn" @click="addSucc">我知道了</div>
      </div>
    </div>
  </div>
</template>
<script>
import { postDetails } from '@/api/zone'
import { addClassCard, editClassCard, classUserPermissions } from '@/api/grade'
import { columnsCase, objectCase, toolbarOptions } from './data'
import uploaderVideo from './components/uploaderVideo.vue'
import { quillEditor } from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import withRouteTracking from '@/utils/withRouteTracking'
import { traceClickURL, debounce } from '@/utils/util'
const UserProfile = {
  components: {
    uploaderVideo,
    quillEditor
  },
  data () {
    return {
      content: '',
      subjectName: '',
      form: {},
      areaId: '', // 专区Id
      fileIds: [],
      adminFileMainId: '',
      columnsCase: columnsCase,
      caseValue: '',
      showPicker: false,
      changeRadio: '0',
      fromType: '',
      editorOption: {
        modules: {
          toolbar: toolbarOptions
        },
        theme: 'snow',
        placeholder: '请输入内容...'
      },
      uploadPost: false,
      visiableAdd: false,
      contentMaxLength: 1000,
      isAdmin: false,
    }
  },
  computed: {
    allInput () {
      return this.subjectName.length > 0 && this.content.length > 0
    },
    userInfo () {
      return this.$store.getters.userInfo
    }
  },
  created () {
    this.areaId = this.$route.query.areaId
    this.dccId = this.$route.query.dccId // 帖子ID
    if (this.dccId) {
      postDetails({ postbarId: this.dccId }).then(res => {
        this.areaId = res.data.areaId
        this.subjectName = res.data.subjectName
        this.content = res.data.content
        this.adminFileMainId = this.dccId
        this.$refs.uploadDiv.handleFun(this.adminFileMainId)
      })
    }
    this.fromType = this.$route.query.fromType
    this.classPermissions = JSON.parse(sessionStorage.getItem('classPermissions'))
    if (!(this.classPermissions && this.classPermissions.classId)) {
      this.getClassUserPermissions()
    } else {
      if (this.userInfo.memberType === 1 && this.classPermissions.isAdminPermiss) {
        this.isAdmin = true
      }
      if (this.userInfo.memberType === 0 && this.classPermissions.inClassList && this.classPermissions.userStatus === 1 && this.classPermissions.roleType === 3) {
        this.isAdmin = true
      }
    }
  },
  methods: {
    getClassUserPermissions() {
      const params = {
        classId: this.areaId,
        userId: this.userInfo.id
      }
      classUserPermissions(params).then(res => {
        const data = res.data
        if (this.userInfo.memberType === 1) { // 员工
          if (data.inClassList && [1, 2].includes(data.roleType)) { // 超管，管理员可以发帖
            this.isAdmin = true
          }
        } else {
          if (data.inClassList && data.userStatus === 1 && data.roleType === 3) {
            this.isAdmin = true
          }
        }
      })
    },
    getPlainTextLen(richText) {
      return richText
        .replace(/<[^>]+>/g, '')
        .replace(/ |\n|\r\n|&nbsp;|&ensp;/g, '')
        .replace(/[a-zA-Z]&#7([6-7][0-9]);/g, ' ')
        .replace(/&([a-z]{2,5}|#[0-9]{1,6});/g, ' ')
        .length
    },
    handleAddPost: debounce(function () {
      if (!this.allInput) {
        this.$toast('请输入内容')
        return
      }
      if (this.getPlainTextLen(this.content) > this.contentMaxLength) {
        this.$toast('字数超过1000！')
        return
      }
      if (this.uploadPost) return
      this.uploadPost = true
      let params = {
        id: this.dccId,
        areaId: this.areaId,
        type: '5',
        userId: this.userInfo.id,
        subjectName: this.subjectName, // 标题
        // classContent: this.content,
        content: this.content,
        fileIds: this.uploadList && this.uploadList.length > 0 ? this.uploadList.map(res => res.id) : [],
        kind: '4',
        // 5班级发帖6iep课程7线上答疑8模拟器练习
        // postType: 5
      }
      if (this.fromType === 'case') {
        if (!this.caseValue) {
          this.$toast('请先选择疾病分类！')
          return
        }
        params.anonymity = this.changeRadio
        params.caseType = objectCase[this.caseValue]
      }
      if (params.id) {
        const fileList = this.fileList.filter(item => item.id).map(item => item.id)
        params.fileIds = fileList.concat(params.fileIds)
        params.postbarId = this.dccId
        delete params.kind
        editClassCard(params).then(res => {
          this.visiableAdd = true
          this.editType = 'update'
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      } else {
        delete params.id
        addClassCard(params).then(res => {
          this.visiableAdd = true
          this.editType = 'add'
        }).catch((err) => {
          this.$toast(err.msg)
          this.uploadPost = false
        })
      }
    }, 500),
    addSucc() {
      if (this.editType === 'add') {
        if (this.fromType === 'case') {
          setTimeout(() => { traceClickURL() })
          window.location.href = `${process.env.bingliUrl}/wap/index.html#/homePage?index=1&listType=4`
        } else {
          this.$router.push({
            path: `/gradeHomePage?classId=${this.areaId}`
          })
        }
      } else {
        this.$router.push({
          path: `/dcc`
        })
      }
    },
    onConfirm (e) {
      this.caseValue = e
      this.showPicker = false
    },
    handleUploadSucc (succon) {
      this.uploadList = succon.uploadList
      this.fileList = succon.uploadList
    }
  }
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
.dialog-fixed {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 99;

  .dialog-bg {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(0, 0, 0, .6);
  }
  .dialog-cons {
    position: absolute;
    width: 322px;
    height: 273px;
    background: #fff;
    left: 50%;
    top: 50%;
    border-radius: 20px;
    transform: translate(-50%, -50%);
    .cons-title {
      font-size: 17px;
      color: #000000;
      font-weight: 600;
      line-height: 24px;
      padding-top: 16px;
      text-align: center;
      margin-bottom: 18px;
    }
    .cons-txt {
      font-size: 14px;
      color: #000;
      line-height: 24px;
      padding: 0 35px;
      box-sizing: border-box;
      .txt2 {
        margin-top: 8px;
      }
      .col {
        color: #EB1700;
      }
    }
    .cons-btn {
      width: 240px;
      height: 42px;
      line-height: 42px;
      text-align: center;
      font-size: 16px;
      color: #FFFFFF;
      background: #EB1700;
      border-radius: 100px;
      margin-top: 30px;
      margin-left: 50%;
      transform: translateX(-50%);
    }
  }
}

.add-post {
padding-bottom: 90px;
box-sizing: border-box;
  .upload-imgs {
    display: flex;
    flex-wrap: wrap;
    padding: 16px 14px;
    box-sizing: border-box;

    .video-div {
      width: 109px;
      height: 109px;
      margin-right: 10px;
      position: relative;
      background-color: rgba(247 248 250, .5);
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;

      .div-cross {
        position: absolute;
        top: 0;
        right: 0;
        width: 14px;
        height: 14px;
        background-color: rgba(0, 0, 0, .7);
        border-radius: 0 0 0 12px;

        /deep/ .cross {
          font-size: 10px;
          color: #fff;
          top: -4px;
          right: -3px;
        }
      }

      .video {
        width: 100%;
        height: 100%;
      }

      .icon-play {
        position: absolute;
        width: 36px;
        height: 36px;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }

    /deep/ .van-uploader__wrapper {
      .van-uploader__preview,
      .van-image,
      .van-uploader__upload {
        width: 109px;
        height: 109px;
        margin-right: 10px;

        &:nth-child(3n) {
          margin-right: 0;
        }
      }

      .van-uploader__upload-icon {
        font-size: 36px;
      }
    }
  }

  .upload-title {
    width: 100%;
    border-top: 1px solid #ebedf0;
    box-sizing: border-box;
    padding: 0 14px;

    .input-title {
      line-height: 55px;
      height: 55px;
      border: none;
      border-bottom: 1px solid #ebedf0;
      font-weight: 600;
      outline: none;
      background-color: transparent;
      width: 100%;
      font-size: 18px;
      color: #282828;

      &::placeholder {
        color: #c0c0c2;
      }
    }
  }

  /deep/ .van-field__control {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.8);

    &::placeholder {
      color: #c0c0c2;
    }
  }

  .radio1 {
    /deep/ .van-field__control {
      text-align: right;
    }
  }

  .div-flex {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 14px;
    height: 42px;
    border-bottom: 1px solid #ebedf0;
    font-size: 14px;
  }

  .fixed-btn {
    position: fixed;
    bottom: 24px;
    left: 14px;
    width: calc(100vw - 28px);
    height: 42px;
    border-radius: 100px;
    background-color: #e6e6e6;
    font-size: 16px;
    color: #aeaeae;
    text-align: center;
    line-height: 42px;
    font-weight: 500;

    &.upload {
      color: #fff;
      background-color: #C0C0C0;
    }

    &.cur {
      color: #fff;
      background-color: #EB1700;
    }
  }
}

/deep/.field-color {
  .van-cell__title {
    color: #333;
    position: relative;
    padding-left: 8px;
    box-sizing: border-box;

    &::before {
      content: "*";
      font-size: 14px;
      color: #FF3C3C;
      width: 12px;
      line-height: 20px;
      position: absolute;
      top: 3px;
      left: 0;
      box-sizing: border-box;
    }
  }
}

.flex-label {
  position: relative;
  padding-left: 8px;
  box-sizing: border-box;

  &::before {
    content: "*";
    font-size: 14px;
    color: #FF3C3C;
    width: 12px;
    line-height: 20px;
    position: absolute;
    top: 3px;
    left: 0;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/grade/addPost.vue